import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg4 from "../../assets/img/4.png";
import projectimage4 from "../../assets/img/p4.png";

const PreviousCard4 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Network analysis of a corpus of laws</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage4} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg4} />{" "}
            <p className="text7">István Szakadát </p>
            <br />
            <p className="text8">
              Associate Professor <br /> Department of Sociology and
              Communications, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              The network structure of the corpus of Hungarian laws issued
              between 1990 and 2022 can be analysed in several ways. The
              internal structure of each law, the qualitative and
              quantitative characteristics of the laws, and the changes in
              the structure of the texts over time can be examined.
              Considering the laws as nodes, and the references among them
              as edges, the legal corpus as a network can be described and
              analysed based on network theory tools, with the help of
              various centrality measures.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Fowler, J. H., Johnson, T. R., Spriggs II, J. F., Jeon,
                  S., & Wahlbeck, P. J. (2007). Network analysis and the
                  law: Measuring the legal importance of Supreme Court
                  precedents.{" "}
                  <span className="text9"> Political Analysis </span>, 15(3),
                  324-346.{" "}
                </li>
                <li>
                  Whalen, R. (2016). Legal networks: The promises and
                  challenges of legal network analysis.
                  <span className="text9"> Mich. St. L. Rev </span>., 539.{" "}
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default PreviousCard4;
